/// <amd-module name="CodeCoverage/CodeCoverageCiTab/CoverageSummaryPoller" />
import { PipelineCoverageSummary } from "CodeCoverage/Clients/Coverage/Contracts/Coverage";
import { CoverageClientName, ICoverageRestClient } from "CodeCoverage/Clients/Coverage/RestClient/Coverage";
import { IVssPageContext } from "VSS/Platform/Context";

export interface PollingOptions {
    // Interval for polling in milliseconds
    interval: number;

    // Stop polling after request count reaches the value limitCount
    limitCount: number;

    // Project guid
    projectId: string;

    // Pipeline run id
    pipelineRunId: number;
}

export class CoverageSummaryPoller {
    private intervalId: number | null;
    private pollCounter: number;
    private coverageClient: ICoverageRestClient;
    private isPolling: boolean;

    constructor(pageContext: IVssPageContext, private callback: (summary: PipelineCoverageSummary) => void, private options: PollingOptions) {
        this.coverageClient = pageContext.getRestClient<ICoverageRestClient>(CoverageClientName);

        this.isPolling = false;
    }

    public startPolling(): void {
        this.isPolling = true;
        this.pollCounter = 0;

        if (this.intervalId == null) {
            // send first poll without the wait
            this.poll();

            this.intervalId = setInterval(this.poll.bind(this), this.options.interval);
        }
    }

    public stopPolling(): void {
        clearInterval(this.intervalId!);
        this.intervalId = null;
        this.isPolling = false;
    }

    private poll(): void {
        if (this.pollCounter >= this.options.limitCount) {
            return;
        }

        // make request and dispatch event
        this.coverageClient
            .getPipelineCoverageSummary(this.options.projectId, this.options.pipelineRunId)
            .then(
                (summary: PipelineCoverageSummary) => {
                    if (this.isPolling) {
                        this.callback(summary);
                        this.pollCountCheck();
                    }
                },
                (reason: Error) => {
                    $DEBUG && console.error("Coverage pipeline summary error, reason: " + reason);
                    this.pollCountCheck();
                }
            )
            .catch((reason: Error) => {
                $DEBUG && console.error("Coverage pipeline summary error, reason: " + reason);
                this.pollCountCheck();
            });

        this.pollCounter++;
    }

    private pollCountCheck(): void {
        if (this.pollCounter >= this.options.limitCount) {
            this.stopPolling();
        }
    }
}
